module.exports = __webpack_public_path__ + "static/img/dollars.dbb6b03e.png";